module.exports = __webpack_public_path__ + "static/img/distance.cd7e3b34.png";